import $ from 'jquery';

// Bootstrap modal whose body is a turbo-frame: element links load the form into it,
// a successful submit closes it, a 422 keeps it open. Widgets init on turbo:frame-load.
const MODAL_SELECTOR = '[data-fac-element-modal]';
const TRIGGER_SELECTOR = '[data-fac-element-modal-link]';
const FRAME_SELECTOR = 'turbo-frame#fare_adapter_configuration_element';
const SPINNER_HTML = '<div class="text-center py-4"><i class="fa fa-spinner fa-pulse fa-fw"></i></div>';

const isModifiedClick = (event) => (
  event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey
);

// Bound once; the modal is re-queried per click since Turbo replaces it on each visit.
let triggerDelegationBound = false;

const openModalOnTriggerClick = (event) => {
  const link = event.target.closest(TRIGGER_SELECTOR);
  if (!link || isModifiedClick(event)) return;

  const modal = document.querySelector(MODAL_SELECTOR);
  if (modal) $(modal).modal('show');
};

const hideModalOnSuccessfulSubmit = (event) => {
  if (event.detail.success) $(event.currentTarget).modal('hide');
};

const setupFareAdapterElementModal = () => {
  const modal = document.querySelector(MODAL_SELECTOR);
  if (!modal) return;

  if (!triggerDelegationBound) {
    document.addEventListener('click', openModalOnTriggerClick);
    triggerDelegationBound = true;
  }

  // detail.success is false for 422 responses; the stable reference lets addEventListener dedupe.
  modal.addEventListener('turbo:submit-end', hideModalOnSuccessfulSubmit);

  // Reset to the loading state on close so the next open doesn't flash a stale form.
  $(modal).off('hidden.bs.modal.facElement').on('hidden.bs.modal.facElement', () => {
    const frame = modal.querySelector(FRAME_SELECTOR);
    if (frame) frame.innerHTML = SPINNER_HTML;
  });
};

export default setupFareAdapterElementModal;
